module.exports = __webpack_public_path__ + "img/riskmanagement-graph1-ar.f93b8ce1.png";